import React from 'react';
import classNames from 'classnames';
import css from './FreeTrialWarning.module.css';
import { Button } from '@mm/components';
import { useFreeTrialUpgradeModal } from '../../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import { useViewActions } from '@mm/state/actions/viewActions';

interface IFreeTrialWarning {
  className?: string;
  isVisible: boolean;
  onUpgradeClick?: ReturnType<
    typeof useFreeTrialUpgradeModal
  >['openFreeTrialUpgradeModal'];
}

export const useFreeTrialWarningProps = (): IFreeTrialWarning => {
  const modal = useFreeTrialUpgradeModal();
  const viewActions = useViewActions();
  return {
    onUpgradeClick: () => {
      viewActions.hideSlideoutMenu();
      modal.openFreeTrialUpgradeModal();
    },
    isVisible:
      modal.isFreeTrial && modal.currentSubscription?.state !== 'future',
  };
};

export const FreeTrialWarningView = ({
  className,
  onUpgradeClick,
  isVisible,
}: IFreeTrialWarning) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={classNames(className, css.container)}>
      Messages sent from Free Trial accounts have "Sent from my MobileMonkey"
      branding.{' '}
      <Button color="link" onClick={onUpgradeClick}>
        Upgrade now to remove
      </Button>
    </div>
  );
};

export const FreeTrialWarning = props => {
  const freeTrialWarningProps = useFreeTrialWarningProps();
  return <FreeTrialWarningView {...freeTrialWarningProps} {...props} />;
};
